module.exports = __webpack_public_path__ + "img/g_mro_15.444651d7.png";